<template>
  <v-container fluid fill-height align-start ma-0 pa-2 class="notice">
    <!-- 미리보기 팝업 -->
    <i-dxpopup
      :popupVisible="popupVisible"
      :title="popupTitle"
      @popupCloseButtonClick="popupCloseButtonClick"
      :vHtmlContent="'test'"
      :height="'650'"
      width="90vw"
      max-width="650"
    >
      <template v-slot:grid>
        <i-preview :key="componentKey" :fileList="files" :propsFileData="selectedFileData"></i-preview>
      </template>
    </i-dxpopup>
    <i-card-vertical
      :headerTitle="'파일관리'"
      :useBtnList="!readOnly ? buttonUseList : []"
      @btnDelete="btnDelete()"
    >
      <template v-slot:body>
        <v-layout column>
          <DxDataGrid
            id="fileDataGrid"
            class
            width="100%"
            :height="'290px'"
            :ref="dxDataGridRef"
            :data-source="files"
            :column-auto-width="true"
            key-expr="id"
            :key="clntId"
          >
            <DxPaging :enabled="true" :page-size="5" />
            <DxScrolling row-rendering-mode="standard" />

            <DxColumn
              data-field="createdAt"
              data-type="date"
              caption="등록일자"
              format="yyyy.MM.dd HH:mm:ss"
              width="145px"
              alignment="center"
              :allow-editing="false"
            />

            <DxColumn
              data-field="fileNm"
              caption="파일명"
              data-type="string"
              :allow-editing="false"
              cell-template="fileTemplate"
            />
            <template #fileTemplate="{data: cellInfo}">
              <div class="d-flex">
                <div :title="cellInfo.value">{{ cellInfo.value }}</div>
                <div v-if="cellInfo.row.data.extension != null">.{{ cellInfo.row.data.extension }}</div>
              </div>
            </template>

            <DxColumn
              data-field="extension"
              caption="확장자"
              width="60px"
              data-type="string"
              alignment="center"
              cell-template="extensionIconTemplate"
              :allow-editing="false"
              css-class="iconCell"
            />

            <DxColumn
              data-field="fileSize"
              caption="용량"
              width="70px"
              data-type="string"
              alignment="right"
              :allow-editing="false"
            />

            <!-- <DxColumn data-field="filePath" caption="경로" data-type="string" width="180px" /> -->

            <DxColumn
              data-field="useYn"
              width="40px"
              data-type="boolean"
              caption="사용"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="useYn1"
              width="80px"
              data-type="boolean"
              caption="미리보기"
              cell-template="preview"
              :allow-editing="false"
            />
            <template #preview="{ data: cellInfo }">
              <v-btn
                elevation="0"
                color="btn_sub"
                dark
                x-small
                class="rounded"
                v-if="!cellInfo.data.__created__"
                @click="previewClick(cellInfo.data)"
              >
                <!-- <svg-icon icon-class="preview" style="height: 1rem;"></svg-icon> -->
                미리보기
              </v-btn>
            </template>

            <DxColumn
              data-field="__created__"
              caption="다운로드"
              data-type="string"
              alignment="center"
              width="80px"
              cell-template="downloadTemplate"
              :allow-sorting="false"
              :allow-editing="false"
            />

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox
                :value="cellInfo.value == 'Y' ? true : false"
                :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
              />
            </template>

            <template #downloadTemplate="{ data : cellInfo }">
              <v-btn
                elevation="0"
                color="btn_sub"
                width="55"
                dark
                x-small
                class="rounded"
                v-if="cellInfo.value == null"
                @click="fileDownload(cellInfo.data)"
              >
                <!-- <svg-icon icon-class="download" style="height: 1rem;"></svg-icon> -->
                <div>다운로드</div>
              </v-btn>
            </template>

            <template #extensionIconTemplate="{ data:cellInfo }">
              <svg-icon
                class="excel_icon file_icon"
                v-if="cellInfo.value == 'xlsx' || cellInfo.value == 'xls'"
                icon-class="excel"
              />

              <svg-icon
                class="jpg_icon file_icon"
                v-else-if="cellInfo.value == 'jpg'"
                icon-class="jpg"
              />

              <svg-icon
                class="pdf_icon file_icon"
                v-else-if="cellInfo.value == 'pdf'"
                icon-class="pdf"
              />

              <svg-icon
                class="png_icon file_icon"
                v-else-if="cellInfo.value == 'png'"
                icon-class="png"
              />

              <svg-icon
                class="txt_icon file_icon"
                v-else-if="cellInfo.value == 'txt'"
                icon-class="txt"
              />

              <svg-icon
                class="ppt_icon file_icon"
                v-else-if="cellInfo.value == 'ppt' || cellInfo.value == 'pptx'"
                icon-class="ppt"
              />

              <svg-icon
                class="zip_icon file_icon"
                v-else-if="cellInfo.value == 'zip' || cellInfo.value == 'cab'"
                icon-class="zip"
              />

              <svg-icon
                class="doc_icon file_icon"
                v-else-if="cellInfo.value == 'doc' || cellInfo.value == 'docx'"
                icon-class="doc"
              />

              <svg-icon
                class="hwp_icon file_icon"
                v-else-if="cellInfo.value == 'hwp' || cellInfo.value == 'hwpx'"
                icon-class="hwp"
              />

              <svg-icon class="file_default_icon file_icon" v-else icon-class="file_default" />
            </template>
          </DxDataGrid>
          <div class="widget-container">
            <DxFileUploader
              :ref="dxFileUploader"
              accept="*"
              :multiple="true"
              upload-mode="useButtons"
              selectButtonText="Select File"
              :show-file-list="false"
              labelText
              width="100%"
              dialog-trigger="[role=btnUpload]"
              drop-zone="#dropzone-external"
              @uploaded="onUploaded"
              @upload-error="onUploadError"
              @value-changed="onValueChanged"
              :visible="false"
            />
          </div>

          <!-- 드래그 존  -->
          <div v-if="!readOnly" id="dropzone-external">
            <div>여기에 파일 놓기</div>
          </div>
        </v-layout>
      </template>
    </i-card-vertical>
  </v-container>
</template>

<script>
import { deleteFiles, downloadFile, getFile, multiFileUpload } from '@/api/baseManage/fileUpload'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { getCurrentDate } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'
import iDxPopup from '@/components/common/iDxPopup.vue'
import IPreview from '@/components/common/iPreview.vue'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'

import { DxFileUploader } from 'devextreme-vue/file-uploader'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'detailFileUpload',
  components: { DxFileUploader, 'i-dxpopup': iDxPopup, IPreview },
  props: {
    targetId: {
      type: String,
      default: () => ''
    },
    targetType: {
      type: String,
      default: () => ''
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      componentKey: 0,
      popupVisible: false,
      popupTitle: '미리보기',
      buttonUseList: [
        'btnUpload', //업로드
        'btnDelete' //삭제
      ],
      dxDataGridRef: 'fileDataGrid',
      dxFileUploader: 'uploaderContainer',
      files: [],
      maxFileSize: 1073741824,
      clntId: this.getClntId(),
      selectedFileData: 0,
      saveFileList: {
        insert: [],
        delete: []
      }
    }
  },
  watch: {
    targetId() {
      console.log('#@22222 ')
      // 신규 문서일시 초기화
      if (this.targetId === '') {
        this.files = []
      }
    }
  },
  computed: {
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance
    }
  },
  beforeMount() {},
  created() {},
  mounted() {},
  activated() {
    // 신규 문서일시 초기화
    if (this.targetId === '') {
      this.files = []
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    btnSearch(noti) {
      this.openLoading()
      this.clntId = this.getCompId()
      let searchParams = {
        targetId: this.targetId,
        targetType: this.targetType,
        clntId: this.clntId
      }
      this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      getFile(searchParams, noti)
        .then(res => {
          if (res.success) {
            this.files = []
            res.list.forEach(el => {
              if (el.targetId === searchParams.targetId) this.files.push(el)
            })
          }
        })
        .finally(() => this.endLoading())
    },
    async btnSave(fileList) {
      await this.fileRemove(fileList.delete) // 삭제리스트 파일 삭제
      await this.fileSave(fileList.insert)
      this.saveFileList = {
        insert: [],
        delete: []
      }
    },
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      console.log('## selectedRows', selectedRows, this.files)
      let newData = this.files.slice() // 기존 files 배열을 복사하여 newData 초기화
      this.vToastifyPrompt(
        this.$t('파일을 삭제하시겠습니까?'),
        'info',
        current => {
          selectedRows.forEach(row => {
            // 각 선택된 행에 대해 해당 행의 id와 일치하지 않는 파일만 필터링하여 newData에 추가
            newData = newData.filter(file => row.id != file.id)
          }) // 그리드에서 해당데이터 제거
          this.files = newData
          console.log('## newData', newData)
          // this.saveFileList.insert.findIndex(el=> el.id === newData.)
          // this.saveFileList.insert = newData
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.saveFileList.delete = [...this.saveFileList.delete, ...selectedRows] //삭제 파일 리스트 보관
          let newInsert = this.saveFileList.insert.slice()
          this.saveFileList.delete.forEach(del => {
            newInsert = newInsert.filter(ins => del.id != ins.id)
          })
          this.saveFileList.insert = newInsert
          this.$emit('onFileChanged', this.saveFileList)
        },
        null,
        true
      )

      // this.fileRemove(selectedRows)
    },
    fileSave(selectedRows) {
      if (selectedRows.length > 0) {
        return new Promise((resolve, reject) => {
          this.openLoading()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          let formData = new FormData()
          let i = 0
          selectedRows.forEach(element => {
            formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
            formData.append('fileList[' + i + '].fileVO.targetId', this.targetId)
            formData.append('fileList[' + i + '].fileVO.targetType', this.targetType)
            formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
            formData.append('fileList[' + i + '].fileVO.clntId', this.clntId)
            i++
          })
          multiFileUpload(formData, false)
            .then(res => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .finally(() => {
              this.endLoading()
              resolve(true)
            })
        })
      }
    },
    fileRemove(files) {
      if (files.length > 0) {
        this.openLoading('deleting')
        deleteFiles(files, false)
          .then(res => {
            if (res.success) {
              this.btnSearch(false)
            }
          })
          .finally(() => {
            this.endLoading()
          })
      }
    },
    previewClick(data) {
      this.selectedFileData = data
      this.forceRerender()
      this.popupVisible = true
    },
    fileDownload(rowData) {
      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        clntId: rowData.clntId,
        writeDt: rowData.writeDt,
        docNo: rowData.docNo
      }

      downloadFile(params)
        .then(res => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${rowData.fileNm}.${rowData.extension}`
          link.click()
        })
        .finally(() => this.endLoading())
    },
    popupCloseButtonClick() {
      this.selectedFileData = null
      this.popupVisible = false
    },
    onUploaded(e) {
      e.component._files.forEach((element, index) => {
        if (element._isLoaded) {
          this.fileUploader.removeFile(index)
        }
      })
      notify(this.$t('파일이 업로드 되었습니다.'), 'success', 300)
    },
    onUploadError(e) {
      e.component._files.forEach((element, index) => {
        if (element._isError) {
          this.fileUploader.removeFile(index)
          notify(this.$t('파일을 업로드 할 수 없습니다.'), 'error', 300)
        }
      })
    },
    onValueChanged(e) {
      // reset 이벤트는 재귀적으로 이 이벤트를 부르기 때문에 0일때 return 시킴
      if (e.value == null || e.value.length == 0) return

      this.openLoading()
      for (const element of e.value) {
        if (element.size >= this.maxFileSize) {
          notify(this.$t('파일이 용량이 1GB를 초과했습니다.'), 'error', 300)
          continue
        }
        let subFileName = this.getExtension(element.name)
        if (subFileName[0].length > 200) {
          notify(this.$t('파일의 이름이 200자 이상입니다.'), 'error', 300)
          continue
        }
        // if (!this.allowedFileExtensions.includes('.' + subFileName[1])) {
        //   notify(this.$t('업로드할 수 없는 확장자입니다.'), 'error', 300)
        //   continue
        // }
        let writeDt = getCurrentDate()
          .split('-')
          .join('')
        let newRow = {
          id: this.files.length + 1,
          clntId: this.clntId,
          writeDt: writeDt,
          doc_no: (this.files.length + 1).toString().padStart(5, '0'),
          file: new File([element], `${subFileName[0]}.${subFileName[1]}`),
          fileNm: subFileName[0],
          extension: subFileName[1],
          fileSize: this.getfileSize(element.size),
          useYn: 'Y',
          targetId: this.targetId,
          targetType: this.targetType
        }

        Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })

        this.files.unshift(newRow)
        this.saveFileList.insert = [...this.saveFileList.insert, ...[newRow]]
        this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
      }
      this.GetDataGrid(this.dxDataGridRef).updateDimensions()
      this.fileUploader.reset()
      this.$emit('onFileChanged', this.saveFileList)
      console.log('### this.files', this.files)
      this.endLoading()
    },
    getExtension(fileName) {
      let fileLen = fileName.length

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot + 1, fileLen).toLowerCase()
      let baseName = fileName.substring(0, lastDot)
      return [baseName, extension]
    },
    getfileSize(size) {
      return (size / 1048576).toFixed(3) + 'MB'
    }
  }
}
</script>

<style lang="scss" scoped>
#dropzone-external {
  height: 180px;
  background-color: #e1e7f2;
  border-width: 1px;
  border-style: dashed;
  padding: 10px;
  opacity: 0.4;
  align-items: center;
}
#dropzone-external div {
  font-size: 16px;
  color: #6e6d6d;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
